import { useState } from 'react';
import { createResource,getResources,deleteResource, updateResource} from '../../../router/api';
import toast from 'react-hot-toast';

interface CancelQuoteModalProps {
  isOpen: boolean;
  onClose: () => void;
  quote: any;
  onCancelled: () => void;
}

export default function CancelQuoteModal({
  isOpen,
  onClose,
  quote,
  onCancelled,
}: CancelQuoteModalProps) {
  const [motif, setMotif] = useState('');
  const [loading, setLoading] = useState(false);

  if (!isOpen || !quote) return null;

  const handleConfirmCancel = async () => {
    if (!motif.trim()) {
      toast.error('Le motif d’annulation est obligatoire');
      return;
    }

    setLoading(true);

    try {
      await createResource(`devis-bcc/${quote.id}/annuler`, {
        motif,
      });

      toast.success('Devis annulé avec succès');
      onCancelled();
      onClose();
    } catch (e: any) {
      toast.error(e.response?.data?.message || 'Erreur lors de l’annulation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white w-full max-w-md rounded-xl shadow-lg">
        {/* Header */}
        <div className="px-6 py-4 border-b flex justify-between items-center">
          <h3 className="text-lg font-semibold text-gray-900">Annuler le devis</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-4 space-y-4">
          <div className="text-sm text-gray-700">
            Vous êtes sur le point d’annuler le devis :
            <div className="font-medium text-gray-900 mt-1">{quote.numero}</div>
            <div className="text-xs text-gray-500">
              Client : {quote.client?.raison_sociale ?? '—'}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Motif d’annulation <span className="text-red-500">*</span>
            </label>
            <textarea
              rows={4}
              className="w-full border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-red-500 focus:outline-none"
              placeholder="Ex : Client non intéressé, erreur de devis, etc."
              value={motif}
              onChange={(e) => setMotif(e.target.value)}
            />
          </div>

          <div className="bg-red-50 border border-red-200 rounded-md p-3 text-sm text-red-700">
            ⚠️ Cette action est définitive. Le devis ne pourra plus être modifié ni envoyé.
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm border rounded-md text-gray-700 hover:bg-gray-50"
          >
            Annuler
          </button>
          <button
            onClick={handleConfirmCancel}
            disabled={loading}
            className="px-4 py-2 text-sm rounded-md text-white bg-red-600 hover:bg-red-700 disabled:opacity-60"
          >
            {loading ? 'Annulation...' : 'Confirmer l’annulation'}
          </button>
        </div>
      </div>
    </div>
  );
}
